import React from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfFontFamily, pdfRadius } from '../theme';
import type { SchoolBranding } from '../types';

interface Props {
  branding: SchoolBranding;
  /** Square edge in pt. */
  size: number;
}

const styles = StyleSheet.create({
  image: { objectFit: 'contain' },
  monogram: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: pdfRadius.md,
    backgroundColor: pdfColors.brand,
  },
  initial: {
    fontFamily: pdfFontFamily.sans,
    fontWeight: 700,
    color: pdfColors.textOnDark,
  },
});

/** School logo at a fixed square size, or a brand monogram when the school
 *  has not uploaded one. Shared by the page masthead and the admit card. */
const LogoMark: React.FC<Props> = ({ branding, size }) => {
  if (branding.logoDataUrl) {
    return <Image src={branding.logoDataUrl} style={[styles.image, { width: size, height: size }]} />;
  }
  return (
    <View style={[styles.monogram, { width: size, height: size }]}>
      <Text style={[styles.initial, { fontSize: size * 0.45 }]}>
        {branding.name?.[0]?.toUpperCase() ?? 'S'}
      </Text>
    </View>
  );
};

export default LogoMark;
